import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { TetrisThemeProvider } from '@pocketlaw/tetris';
export function Providers(props) {
    const { children } = props;
    return (<TetrisThemeProvider>
      <I18nProvider i18n={i18n}>{children}</I18nProvider>
    </TetrisThemeProvider>);
}
